export default __webpack_public_path__ + "static/media/Flavory.1276950e.mp3";